import { mountFusionWorld } from "./fusion-world.js?v=20260730-1";

const section = document.querySelector("[data-flight]");
const header = document.querySelector("[data-header]");
const title = document.getElementById("flight-title");
const chapters = [...document.querySelectorAll("[data-flight-chapter]")];
const world = document.getElementById("world");
const progressLine = document.querySelector("[data-fusion-progress]");
const progressNumber = document.querySelector("[data-fusion-percent]");
const flightSkip = document.querySelector(".flight-skip");
const wipe = document.querySelector("[data-fusion-wipe]");
const wipeStrips = [...document.querySelectorAll("[data-fusion-wipe] i")];
let fusion = { setProgress() {}, ready: Promise.resolve() };

try {
  fusion = mountFusionWorld(world);
} catch (error) {
  world.classList.add("is-webgl-lost");
  console.warn("RiZe fusion cinematic entered static mode.", error);
}

const clamp = value => Math.max(0, Math.min(1, value));
const smooth = value => {
  const v = clamp(value);
  return v * v * (3 - 2 * v);
};
const chapterOpacity = (progress, start, end) => {
  const edge = Math.min(.045, (end - start) * .27);
  return smooth((progress - start) / edge) *
    (1 - smooth((progress - (end - edge)) / edge));
};

let minimumLoaderTime = new Promise(resolve => setTimeout(resolve, 520));
Promise.all([fusion.ready, minimumLoaderTime]).then(() => {
  document.documentElement.classList.add("fusion-ready");
});

let ticking = false;
function update() {
  ticking = false;
  const rect = section.getBoundingClientRect();
  const run = Math.max(1, rect.height - innerHeight);
  const progress = clamp(-rect.top / run);
  fusion.setProgress(progress);

  const wordmarkOpacity = 1 - smooth((progress - .075) / .095);
  title.style.opacity = wordmarkOpacity.toFixed(4);
  title.style.transform =
    `translate(-50%, calc(-50% + ${(1 - wordmarkOpacity) * 22}px)) ` +
    `scale(${1 + (1 - wordmarkOpacity) * .045})`;

  chapters.forEach(chapter => {
    const opacity = chapterOpacity(
      progress,
      Number(chapter.dataset.start),
      Number(chapter.dataset.end),
    );
    chapter.style.setProperty("--chapter-opacity", opacity.toFixed(4));
    chapter.style.setProperty("--chapter-shift", `${(1 - opacity) * 20}px`);
    chapter.setAttribute("aria-hidden", String(opacity < .08));
  });

  wipeStrips.forEach((strip, index) => {
    const direction = index % 2 ? 1 : -1;
    let offset;
    if (progress < .76) {
      const close = smooth((progress - .55) / .085);
      const pass = smooth((progress - .64) / .09);
      offset = direction * (110 * (1 - close) - 110 * pass);
      strip.style.backgroundColor = "#edede8";
    } else {
      const close = smooth((progress - .77) / .065);
      const pass = smooth((progress - .835) / .07);
      offset = -direction * (110 * (1 - close) - 110 * pass);
      strip.style.backgroundColor = "#020202";
    }
    strip.style.transform = `translate3d(0,${offset.toFixed(3)}%,0)`;
  });
  wipe?.classList.toggle("is-exit", progress >= .76);

  const inversion = smooth((progress - .62) / .04) *
    (1 - smooth((progress - .80) / .05));
  section.style.setProperty("--fusion-inversion", inversion.toFixed(4));
  section.classList.toggle("is-inverted", inversion > .52);
  if (progressLine) progressLine.style.transform = `scaleX(${progress})`;
  if (progressNumber) progressNumber.textContent = String(Math.round(progress * 100)).padStart(3, "0");
  if (flightSkip) {
    const skipVisibility = 1 - smooth((progress - .9) / .06);
    flightSkip.style.opacity = skipVisibility.toFixed(4);
    flightSkip.style.transform = `translate3d(0,${(1 - skipVisibility) * 10}px,0)`;
    flightSkip.style.pointerEvents = skipVisibility > .2 ? "auto" : "none";
  }
  header?.classList.toggle("is-solid", progress > .065);
}

function requestUpdate() {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(update);
}

addEventListener("scroll", requestUpdate, { passive: true });
addEventListener("resize", requestUpdate, { passive: true });
update();
